import { COLLECTION_PLACES_PER_PAGE } from "@/constants/collection"
import {
  CollectionRef,
  CollectionResponse,
  CollectionSummary,
} from "@/types/collection"
import { PlaceRef } from "@/types/entity"
import { LocationSearchHit } from "@/types/place"

import { BaseApi } from "@/lib/base-api"
import { DEFAULT_PLACES_PER_PAGE, PagingMeta } from "@/lib/paging"

export class CollectionsApi extends BaseApi {
  async fetchCollection(
    ref: CollectionRef,
    page = 1,
    perPage: number = COLLECTION_PLACES_PER_PAGE,
    viewToken?: string
  ) {
    let url = `/api/saved_collections/${ref}?page=${page}&per_page=${perPage}`

    if (viewToken) {
      url += `&t=${viewToken}`
    }

    return await this.get<CollectionResponse>(url)
  }

  async fetchCollections({
    isPublic,
    page = 1,
    perPage = DEFAULT_PLACES_PER_PAGE,
    placeRef,
  }: {
    isPublic?: boolean
    page?: number
    perPage?: number
    placeRef?: PlaceRef
  }) {
    let url = `/api/saved_collections?page=${page}&per_page=${perPage}`

    if (isPublic !== undefined) {
      url += `&public=${isPublic}`
    }

    if (placeRef) {
      url += `&place_ref=${placeRef}`
    }

    return await this.get<{ data: CollectionSummary[]; meta: PagingMeta }>(url)
  }

  async fetchPublicUserCollections({
    handle,
    page = 1,
    perPage = DEFAULT_PLACES_PER_PAGE,
  }: {
    handle: string
    page?: number
    perPage?: number
  }) {
    return await this.get<{ data: CollectionSummary[]; meta: PagingMeta }>(
      `/api/saved_collections?handle=${handle}&public=true&page=${page}&per_page=${perPage}`
    )
  }

  async fetchCollectionBestMatchLocation({ ref }: { ref: CollectionRef }) {
    return await this.get<{ location: LocationSearchHit }>(
      `/api/saved_collections/${ref}/best-location`
    )
  }
}
